import * as React from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';

export const ProcessingProgressIndicator: React.FunctionComponent = () => (
  <React.Fragment>
    <ProgressIndicator label="Processing details" description="" />
  </React.Fragment>
);